module.exports = __webpack_public_path__ + "img/promotion-1.954b721f.png";